import './index.scss';
import * as jQuery from 'jquery';
window.$ = jQuery;
import Typeahead from 'typeahead.js';

export const shmAutocomplete = {
    init: function(inputAddress) {
        inputAddress = $(inputAddress);
        inputAddress.typeahead({hint: true, highlight: true, minLength: 1}, {
            limit: 8,
            source: function(str, callback, asyncCallback) {
                const overlaps = [];
                ymaps.suggest(str).then(function(items) {
                    $(items).each(function() {
                        overlaps.push(this.displayName);
                    });
                    asyncCallback(overlaps);
                });
            },
        });
        const me = false;
        inputAddress.on('typeahead:selected', function() {
            const address = inputAddress.val();
            ymaps.geocode(address).then(function(res) {
                const coords = res.geoObjects.get(0).geometry.getCoordinates();
                console.log('it is here', coords);
                yaMap.setCenter(coords);
                yaMap.setZoom(12);

                if (me) {
                    yaMap.geoObjects.remove(me);
                }

                sortAddress(coords);
            });
        });
    },
};
